// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oh-wardrobe-button {\n  background: none;\n  cursor: pointer;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  padding: 0;\n  margin-right: 1em;\n  font-weight: bold;\n  outline: none;\n}\n.oh-wardrobe-button .active {\n  display: none;\n}\n.oh-wardrobe-button.active .default,\n.oh-wardrobe-button:hover .default {\n  display: none;\n}\n.oh-wardrobe-button.active .active,\n.oh-wardrobe-button:hover .active {\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
